"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var t=require("styled-components");exports.default=e=>t.css`
    @supports not (aspect-ratio: auto) {
      &::before {
        float: left;
        padding-top: ${(t=>{const[e,o]=t.replace(":","/").split("/").map((t=>parseInt(t.trim())));return`${(o/e*100).toFixed(2)}%`})(e)};
        content: "";
      }
      &::after {
        display: block;
        content: "";
        clear: both;
      }
    }
  `;



//////////////////
// WEBPACK FOOTER
// ./~/@vds-core/calendars/~/@vds-core/utilities/cjs/components/JavaScriptStyleHelpers/aspectRatioPolyfill.js
// module id = 896
// module chunks = 0